export default __webpack_public_path__ + "static/media/rotate-right.437acbbc.svg";